<template>
  <div class="" style="width: 100%;">

    <header>
      <v-header></v-header>
    </header>

    <div class="body">

      <template>
        <el-carousel :height="imgHeight" :interval="5000" arrow="always">
          <el-carousel-item v-for="(item, index) in imglist" :key="index">
            <a :href="item.imgurl"><img ref="imgHeight" :src="item.image" style="width: 100%;" /></a>
          </el-carousel-item>
        </el-carousel>
      </template>

      <template>
        <div style="height: 170px;line-height: 160px;text-align: center;background-color: white">
          <p style="font-size: 34px;color: #2497d4;">以专业的检测验证服务，为美好生活提供保障！</p>
        </div>
        <div style="height: 320px;text-align: center;background-color: #ebeef3;min-width: 1200px">
          <div>
            <div class="checkClass">
              <el-input placeholder=" 请输入证书编号..." style="width: 750px;" v-model="infonumber">
                <template slot="prepend">校准证书信息查询</template>
                <template slot="append">
                  <img src="../assets/search.png" @click="serachinfo"
                    style="cursor: pointer; vertical-align: bottom;height: 50px"></template></el-input>
            </div>

            <div  class="rxClass" style="top: 40px!important;background-color: rgb(10, 186, 239);cursor: pointer;"
            @click="$router.push('/login')">
              <div style="height: 90px;position: absolute;top: 12px;">
                <div style="text-align: center;">

                  <div style="text-align: center;line-height: 35px;">
                    <!--<p style="font-size: 16px;color: #4c5159;">服务热线</p>-->
                    <p
                      style="font-size: 30px;color: #2497d4;padding-left: 99px;color: rgb(254, 254, 254);padding-top: 14px;">
                      我的证书
                    </p>
                  </div>
                </div>

              </div>
            </div>



          </div>
          <div>
            <div class="checkClass">
              <el-input placeholder=" 请输入防伪编号..." style="width: 750px;" v-model="number">
                <template slot="prepend">验证报告防伪查询</template>
                <template slot="append">
                  <img src="../assets/search.png" @click="goCheck"
                    style="cursor: pointer; vertical-align: bottom;height: 50px"></template></el-input>
            </div>

            <div class="rxClass">
              <div style="height: 90px;text-align: left">
                <div style="display: inline-block;padding-left: 15px;padding-top: 20px">
                  <img src="../assets/phone_icon.png">
                </div>
                <div style="display: inline-block;text-align: left;line-height: 35px;position: relative;bottom: 15px">
                  <!--<p style="font-size: 16px;color: #4c5159;">服务热线</p>-->
                  <p style="font-size: 30px;color: #2497d4">0571 - 88156669</p>
                </div>
              </div>
            </div>
          </div>



        </div>
      </template>


      <template>
        <div style="background-color: white;padding:25px;padding-bottom: 50px">
          <p style="font-size: 34px;color: #333333;text-align: center;padding: 25px">我们的服务</p>
          <div style="text-align: center">
            <div style="margin-bottom: 100px">
              <img src="../assets/bg1.jpg" style="margin-right:100px">
              <img src="../assets/bg2.jpg">
            </div>
            <div>
              <img src="../assets/bg3.jpg" style="margin-right:100px">
              <img src="../assets/bg4.jpg">
            </div>

          </div>
        </div>
      </template>

      <div>

        <el-dialog title="查询结果如下：" :modal="false" :visible.sync="dialogVisible" width="50%" >
          <div style="border-bottom: 1px solid #CCC;"></div>
          <div>
            <div class="table_bor bgc250" style="  margin-top: 12px;">
              <div class="table_bor_left">样品名称</div>
              <div style="line-height: 36px;padding-left: 5px;">{{ Formlist.samplename }}</div>
            </div>
            <div class="table_bor">
              <div class="table_bor_left">出厂编号</div>
              <div style="line-height: 36px;padding-left: 5px;">{{ Formlist.factorynumber }}</div>
            </div>
            <div class="table_bor bgc250">
              <div class="table_bor_left">型号规格</div>
              <div style="line-height: 36px;padding-left: 5px;">{{ Formlist.modelname }}</div>
            </div>
            <div class="table_bor">
              <div class="table_bor_left">生产厂家</div>
              <div style="line-height: 36px;padding-left: 5px;">{{ Formlist.manufacturer }}</div>
            </div>
            <div class="table_bor bgc250">
              <div class="table_bor_left">证书编号</div>
              <div style="line-height: 36px;padding-left: 5px;">{{Form.certificateno}}</div>
            </div>
            <div class="table_bor">
              <div class="table_bor_left">证书单位</div>
              <div style="line-height: 36px;padding-left: 5px;">{{Form.certificatecompany}}</div>
            </div>
            <div class="table_bor bgc250" style="border-bottom: 1px solid #ccc;">
              <div class="table_bor_left">校准日期</div>
              <div style="line-height: 36px;padding-left: 5px;">{{Form.regulatortime}}</div>
            </div>


          </div>
          <span slot="footer" class="dialog-footer" >

            <el-button type="primary" @click="$router.push('/login'),dialogVisible = false">登陆后可查看更多证书信息</el-button>
          </span>
        </el-dialog>
      </div>
    </div>

    <footer>
      <v-footer>

      </v-footer>

    </footer>
  </div>
</template>

<script>
import vheader from '../components/header/header'
import vfooter from '../components/footer/footer'
export default {
  name: 'index',
  components: {
    vheader,
    vfooter,
  },
  data() {
    return {
      dialogVisible: false,
      name: '',
      imgHeight: '',
      number: '',
      infonumber:"",//证书编号
      imglist: [],
      titleary: [{ url: '', name: '' }],
      Form:{},
      Formlist:{},
    }

  },

  mounted() {
    let that = this;
    that.imgHeight = '620px';

    this.$common.checkImg('https://static.hzjly.cn/authorizationserver/img/banner1.jpg');

    window.onresize = function temp() {
      // 通过点语法获取img的height属性值
      that.imgHeight = `${that.$refs.imgHeight['0'].height}px`
    }
    this.GetScrollImageList();
  },
  methods: {
    serachinfo(){
      let arr=0
      if (this.infonumber.match(/^[Z][J][H][Y]-[J]-([0-9]{8})-([0-9]{2})-([0-9]{3})[G]([0-9]{1})|[Z][J][H][Y]-[J]-([0-9]{8})-([0-9]{2})-([0-9]{3})$/i)){
       console.log(1111)
          arr=this.infonumber.split("-")[2]
          let date=new Date()
          let year= date.getFullYear() 
          let month=(date.getMonth()+1)<10?"0"+(date.getMonth()+1):(date.getMonth()+1)
          let day=date.getDate()<10?"0"+(date.getDate()):(date.getDate())
          let time=year+month+day
         // console.log(time)
     
          // if(time<arr){

          // }
      this.Form={}
      this.Formlist={}
      this.$axios.get("https://www.zjhylab.com/jzapi/ViewCertificate/GetCertificateByGuidNo", {
        params: { 
          guid: '00000000-0000-0000-0000-000000000000', 
          certificateno: this.infonumber, 
        }
      })
        .then(res => {
          var data = JSON.parse(res.data);
        //  console.log(data);
          if(data.results.result==false){
            this.$message({
              message: data.results.data,
              type: 'warning'
            });
            return;
          }else{
                this.Form=data.results.result
          this.Formlist=data.results.result.checkdevrow[0]
         /// console.log(this.Formlist,1111)
          this.dialogVisible = true
          }
      
        })


      }else{
        this.$message({
          message: '请正确填写校准证书上的“证书编号”!',
          type: 'warning'
        });
        
      }


      
 


    },
 

   

    goCheck() {
      this.number = this.number.trim();

      let _this = this;
      this.$axios.get("https://xyz.zjhylab.com/api/PublicResource/GetReportByNumber", {
        params: { number: this.number, type: 1 }
      })
        .then(res => {
          var data = res.data;
          console.log(data);
          console.log(data.results.result);
          if (data.results.result) {
            this.$router.push({ path: '/check', query: { number: this.number } });
          } else {
            this.$message({
              message: data.results.data,
              type: 'warning'
            });
          }
        })
        .catch(err => {

        });


    },
    GetScrollImageList() {
      this.$axios.get("https://www.zjhylab.com/api/ShouYe/GetScrollImageList", {
        params: {

        }
      })
        .then(res => {
          var data = JSON.parse(res.data);
          console.log(data);
          if (data.results.rows) {
            this.imglist = data.results.rows;
          } else {
            this.$message({
              message: data.results.data,
              type: 'warning'
            });
          }
        })
        .catch(err => {

        });
    },


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table_bor {
  width: 97%;
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  margin-left: 12px;
  height: 36px;
  display: flex;
}

.table_bor_left {
  width: 120px;
  height: 36px;
  border-right: 1px solid #ccc;
  text-align: center;
  line-height: 36px;
}

.bgc250{
  background-color: rgb(250, 250, 250);
}
>>>.el-dialog__footer{
  text-align: center;
}
.checkClass {
  height: 90px;
  line-height: 90px;
  background-color: white;
  width: 800px;
  margin: 0 auto;
  display: inline-block;
  margin-top: 40px;
  -moz-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
}

.checkClass>>>.el-input__inner {
  height: 52px !important;
}

.checkClass>>>.el-input-group__append {

  /*border:none;*/
  padding: 0;
}

.checkClass>>>.el-input-group__prepend {

  height: 50px !important;
}

.rxClass {
  height: 90px;
  background-color: white;
  width: 325px;
  display: inline-block;
  position: relative;
  top: 22px;
  -moz-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
}

body {
  font: 14px/22px "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
  min-width: 1200px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}


header {
  min-width: 1200px;
  height: 60px;
  line-height: 60px;
  width: 100%;
  position: absolute;
  top: 0;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.6);
  border-bottom: 1px #e6e6e6 solid;
  z-index: 1000;
}


.header {
  height: 100%;
  line-height: 48px;
  background-color: white;
  color: black;
}

.header-btn {
  margin-left: 10px;
  margin-top: 10px;
  background-color: transparent;
  color: #bfbfbf;
  border-radius: 2px;
  padding: 8px 22px
}

.header-btn:hover {
  border: 1px #4aa8f6 solid;
  color: #4aa8f6;
}

.header ul li {
  padding: 0 15px;
  margin: 0;
}

.header ul li:hover {
  cursor: pointer;
  color: #4aa8f6;
  border-bottom: 2px #4aa8f6 solid;
}

footer {
  width: 100%;
  background-color: #252533;
  padding: 15px 0
}

.footer {
  width: 1200px;
  margin: 0px auto;
  color: #fff;
}

.footer-right {
  font-size: 14px;
  line-height: 35px;
  display: inline-block;
  position: relative;
  top: -20px;
  right: -500px;
}

.footer-bottom {
  text-align: center;
  border-top: 1px #333333 solid;
  padding-top: 15px;
}

.footer-content {

  display: inline-block;
  position: relative;
}

.gray {
  color: #999999;
}

.footer-p {
  font-size: 14px;
  line-height: 35px;
  text-align: left;
}

.footer-p p {
  display: inline-block;
  width: 100px;
  white-space: nowrap;
}












.body {
  width: 100%;

}


.el-dropdown-menu__item {
  display: block;
  margin: 0;
}

.el-menu.el-menu--horizontal {
  border-bottom: solid 0px #e6e6e6;
}

.el-menu--horizontal>.el-submenu:hover {
  border-bottom: none;
}

.el-menu--horizontal>.el-submenu>>>.el-submenu__title {

  height: 48px;
  color: white;
  background-color: rgba(0, 0, 0, 0);
}

.el-menu--horizontal>.el-submenu>>>.el-submenu__title i {
  color: #4c5159;
}

.el-menu--horizontal>.el-submenu>>>.el-submenu__title:hover {
  height: 48px;
  color: #1f8eeb !important;
  background-color: rgba(0, 0, 0, 0);
}

.el-menu--horizontal>.el-submenu>>>.el-submenu__title:hover i {
  color: #1f8eeb;
}




.cloud-menu {

  color: #4c5159;
  position: absolute;
  right: 350px;
  background-color: transparent;

  height: 60px
}

.imglist img {
  margin: 15px;
  transition: 0.5s;
}

.imglist img:hover {
  box-shadow: 15px 15px 5px #bdbdbd;
}

.index-pro-right-span {
  position: absolute;
  top: 178px;
  left: 510px;
  z-index: 999;
  color: white;
  padding: 5px 30px;
  border: 1px #ffffff solid;
  font-size: 20px;
  border-radius: 2px;
  transition: 1s;
  cursor: pointer;
}

.index-pro-right-span:hover {

  /*color: #939393;*/
  /*border: 1px #939393 solid;*/
  background: #1f8eeb;
}

.el-dropdown-menu__item[data-v-82b7485c] {

  margin: 0;
}

>>>.el-menu--popup-right-start {
  margin-left: 15px;
  margin-right: 5px;
}

>>>.el-dialog__body {
  padding: 5px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue